import React from "react";
import { NO_DATA_MESSAGE } from "../../../app_constants";

const NoItems = ({ text = NO_DATA_MESSAGE }) => {
  return (
    <td colSpan="5" style={{ display: "contents" }}>
      <div className="text-center my-5">
        <h2>
          {text + " "}
          <svg
            width="30"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            className="c-icon c-icon-custom-size text-danger mb-2"
            role="img"
          >
            <path
              fill="var(--ci-primary-color, currentColor)"
              d="M425.706,86.294A240,240,0,0,0,86.294,425.705,240,240,0,0,0,425.706,86.294ZM256,48A207.1,207.1,0,0,1,391.528,98.345L98.345,391.528A207.1,207.1,0,0,1,48,256C48,141.309,141.309,48,256,48Zm0,416a207.084,207.084,0,0,1-134.986-49.887l293.1-293.1A207.084,207.084,0,0,1,464,256C464,370.691,370.691,464,256,464Z"
              className="ci-primary"
            ></path>
          </svg>
        </h2>
      </div>
    </td>
  );
};

export default NoItems;
